import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { CommandPalette } from './CommandPalette';
import { Sheet, SheetContent } from '../ui/Sheet';
export function AppShell() {
  const [commandOpen, setCommandOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen w-full overflow-hidden bg-background" data-id="element-108">
      {/* Desktop sidebar */}
      <div className="hidden lg:flex lg:w-64 lg:shrink-0" data-id="element-109">
        <Sidebar data-id="element-110" />
      </div>

      {/* Mobile sidebar drawer */}
      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen} data-id="element-111">
        <SheetContent side="left" className="w-72 p-0 border-r-0" data-id="element-112">
          <Sidebar onNavigate={() => setSidebarOpen(false)} data-id="element-113" />
        </SheetContent>
      </Sheet>

      <div className="flex flex-1 flex-col overflow-hidden min-w-0" data-id="element-114">
        <Header onOpenCommand={() => setCommandOpen(true)} onOpenSidebar={() => setSidebarOpen(true)} data-id="element-115" />
        <main className="flex-1 overflow-y-auto bg-muted/30" data-id="element-116">
          <div className="h-full w-full p-4 md:p-6" data-id="element-117">
            <Outlet data-id="element-118" />
          </div>
        </main>
      </div>

      <CommandPalette open={commandOpen} setOpen={setCommandOpen} data-id="element-119" />
    </div>;
}